export const initOptions = [
  'ADVPERSONALIZATION',
  'ATTACH',
  'BEEEDITORENABLE',
  'CHECKUP',
  'COLLABORATIONS',
  'CONTENTSSOURCES',
  'DELSTATS',
  'DELTACALCSEGM',
  'DYNFLD',
  'EMB',
  'GEST',
  'LOCKCONTENTBEEEDITOR',
  'NL',
  'NOENQUEUE',
  'NOIMMEDIATESEND',
  'NOMAILUPTEMPLATES',
  'NONL',
  'NOSCHED',
  'NOSEND',
  'NOSTOPSENDING',
  'PAGES',
  'PERSONALIZATION',
  'PRIVACYBLOCK',
  'SEND',
  'SMTP+',
  'SMTPV2ENABLED',
  'SPAMCHECK',
  'STAT',
  'TAG',
  'TEMPLATESMANAGEMENT',
  'TURNOFFMSHOP',
  'WHITELABEL',
  'SMS',
  'SMSALIAS',
  'SETTINGS',
  'NOSENDSMS',
  'DONOTDISTURBMODE',
  'BEEMSGAIASSISTANT',
  'ENGAGEMENT',
  'MAILUPSHIELD',
  'EMAILSENDERLOCKED'
]

export const initFeatures = [
  'FooterInOverview',
  'TestInboxPlacement',
  'smartPlanning'
]

export const pendoApiQ = 'da1c8b4e-431b-48c0-5e7e-69e9d34ca1b2'

export const datePickerDateFormat = 'yyyy-MM-dd'

//  numero massimo di elementi in componenti Chosen
export const msgInChosenLimit = 100

export const notifySessionPeriod = 5000 // 5s
